// extracted by mini-css-extract-plugin
module.exports = {"UsersVideos":"UsersVideos_UsersVideos__LfCnr"};